import { render, staticRenderFns } from "./VisaAssignmentHistory.vue?vue&type=template&id=28896a66&scoped=true&"
import script from "./VisaAssignmentHistory.vue?vue&type=script&lang=js&"
export * from "./VisaAssignmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./VisaAssignmentHistory.vue?vue&type=style&index=0&id=28896a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28896a66",
  null
  
)

export default component.exports